"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.encodedCookies = void 0;
const tslib_1 = require("tslib");
const js_cookie_1 = tslib_1.__importDefault(require("js-cookie"));
const isArray_1 = tslib_1.__importDefault(require("lodash/isArray"));
const common_1 = require("./common");
const strings_1 = require("./strings");
exports.encodedCookies = {
    set(cookie) {
        const set = ({ key, value, expires, secure }) => {
            js_cookie_1.default.set(key, (0, strings_1.encodeString)(JSON.stringify(value)), {
                expires,
                secure,
            });
        };
        if (!(0, isArray_1.default)(cookie))
            set(cookie);
        else
            cookie.forEach(set);
    },
    get(...keys) {
        return keys.reduce((cookies, key) => {
            const value = (0, strings_1.decodeString)(js_cookie_1.default.get(key));
            return Object.assign(Object.assign({}, cookies), { [key]: (0, common_1.secureDataType)(value) });
        }, {});
    },
    remove(...keys) {
        keys.forEach((key) => js_cookie_1.default.remove(key));
    },
};
